import * as http from '@/util/http'
import { z } from 'zod'

export const CompanyTagSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.url().optional(),
  establishedDate: z.date().optional(),
  capital: z.number().int().optional(),
  employeeCount: z.number().int().optional(),
  imageUrl: z.url().optional(),
  summary: z.array(z.string()).optional(),
  intro: z.any().optional(),
  industries: z.array(CompanyTagSchema).optional(),
  bookmarked: z.boolean(),
})

export type Company = z.input<typeof CompanySchema>

export type SubPath = 'IMG' | 'VIDEO'

export type PresignedUrlReq = {
  subPath: SubPath
  fileName: string
  contentType: string
}

export type PresignedUrlResp = {
  key: string
  url: string
}

// convert null to undefined
export async function fetchCompany(id: number): Promise<Company | undefined> {
  const { data } = await http.get<Company | undefined>(`/api/v1/company/${id}`)
  return data || undefined
}

export type BookmarkAction = 'ADD' | 'REMOVE'

export type BookmarkParam = {
  companyId: number | undefined
  action: BookmarkAction
}

export async function setBookmark({ companyId, action }: BookmarkParam) {
  if (companyId === undefined) return
  return http.put(`/api/v1/company/${companyId}/bookmark`, { payload: { action } })
}

export const PermSchema = z.object({
  canCreate: z.boolean(),
  canWrite: z.boolean(),
  canDelete: z.boolean(),
  canGlobalAccess: z.boolean(),
})

export type Perm = z.infer<typeof PermSchema>

export async function getPerm(): Promise<Perm> {
  const { data } = await http.get<Perm>(`/api/v1/company/perm`)
  return data
}
